import Css from './Customer.module.css';
import SuscriptionsCannellationRate from './SuscriptionsCannellationRate';
import CustomerByStatus from "./CustomerByStatus";
import TopCustomerByRevenue from "./TopCustomerByRevenue";
import ApiConection from "api_ref/ApiConection";
import moment from "moment";
import { useEffect, useState } from "react";
import CustomerCount from "./CustomerCount";
import InCome from "./InCome";
import InvoiceDetails from "./InvoiceDetails";
import Layout4Admin1 from "components/layout/Layout4Admin1";

const arr_table = [
    { invoice_number: '109912', customer_name: 'บริษัท เอบี.จำกัด', due_date: '05/12/2023', status: 'Paid', plan: 'Profressional', invoice_amount: '1,990', payment_type: 'Credit/Debit Card', transaction_date: '2022-10-04 09:00:00' },
    { invoice_number: '109912', customer_name: 'บริษัท เอบี.จำกัด', due_date: '05/12/2023', status: 'Paid', plan: 'Profressional', invoice_amount: '1,990', payment_type: 'Credit/Debit Card', transaction_date: '2022-10-04 09:00:00' },
    { invoice_number: '109912', customer_name: 'บริษัท เอบี.จำกัด', due_date: '05/12/2023', status: 'Paid', plan: 'Profressional', invoice_amount: '1,990', payment_type: 'Credit/Debit Card', transaction_date: '2022-10-04 09:00:00' },
    { invoice_number: '109912', customer_name: 'บริษัท เอบี.จำกัด', due_date: '05/12/2023', status: 'Paid', plan: 'Profressional', invoice_amount: '1,990', payment_type: 'Credit/Debit Card', transaction_date: '2022-10-04 09:00:00' },
    { invoice_number: '109912', customer_name: 'บริษัท เอบี.จำกัด', due_date: '05/12/2023', status: 'Overdue', plan: 'Profressional', invoice_amount: '1,990', payment_type: 'Credit/Debit Card', transaction_date: '2022-10-04 09:00:00' },
    { invoice_number: '109912', customer_name: 'บริษัท เอบี.จำกัด', due_date: '05/12/2023', status: 'Paid', plan: 'Profressional', invoice_amount: '1,990', payment_type: 'Credit/Debit Card', transaction_date: '2022-10-04 09:00:00' }
]

export default function Home() {
    const api = new ApiConection();

    const start_deploy_date = moment('01/01/2023', 'DD/MM/YYYY').format('DD/MM/YYYY');
    const start_month_date = moment('01' + moment().format('/MM/YYYY'), 'DD/MM/YYYY').format('DD/MM/YYYY');
    const end_month_date = moment('01' + moment().format('/MM/YYYY'), 'DD/MM/YYYY').endOf('months').format('DD/MM/YYYY');

    const [dashboard, setDashboard] = useState({
        month_name: '',
        income: 0,
        awaiting: 0,
        customer_count: 0,
        customer_active: 0,
        customer_nonactive: 0,
        status_active: 0,
        status_draft: 0,
        status_hold: 0,
        status_nonactive: 0,
        arr_customer_top_income: [],
        arr_quontations: []
    })

    const handleSetDashboard = (name, value) => {
        setDashboard(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const setApiIncome = async () => {
        let data = {
            date_from: start_month_date,
            date_to: end_month_date
        }

        const resposne = await api.postData('api/AdminDashboard/income', data);
        // console.log(resposne);
        if (resposne.status === true) {
            handleSetDashboard('month_name', resposne.data.month_name);
            handleSetDashboard('income', resposne.data.income);
            handleSetDashboard('awaiting', resposne.data.awaiting);
        }
    }

    const setApiCustomerCount = async () => {
        let data = {
            date_from: start_deploy_date,
            date_to: end_month_date
        }

        const resposne = await api.postData('api/AdminDashboard/customer-count', data);
        // console.log(resposne);
        if (resposne.status === true) {
            handleSetDashboard('customer_count', resposne.data.total);
            handleSetDashboard('customer_active', resposne.data.active);
            handleSetDashboard('customer_nonactive', resposne.data.non_active);
        }
    }

    const setApiCustomerStatus = async () => {
        let data = {
            date_from: start_deploy_date,
            date_to: end_month_date
        }

        const resposne = await api.postData('api/AdminDashboard/customer-status', data);
        // console.log(resposne);
        if (resposne.status === true) {
            handleSetDashboard('status_active', resposne.data.active);
            handleSetDashboard('status_draft', resposne.data.draft);
            handleSetDashboard('status_hold', resposne.data.hold);
            handleSetDashboard('status_nonactive', resposne.data.non_active);
        }
    }

    const setApiCustomerTopIncome = async () => {
        let data = {
            date_from: start_deploy_date,
            date_to: end_month_date
        }

        const resposne = await api.postData('api/AdminDashboard/customer-top-income', data);
        // console.log(resposne);
        if (resposne.status === true) {
            handleSetDashboard('arr_customer_top_income', resposne.data);
        }
    }

    const setApiQuontations = async () => {
        let data = {
            search: {
                create_date_from: start_month_date,
                create_date_to: end_month_date
            },
            pagination: {
                page: 1,
                size: 10
            }
        }

        const resposne = await api.postData('api/Quontation/result', data);
        // console.log(resposne);
        if (resposne.status === true) {
            handleSetDashboard('arr_quontations', resposne.data);
        }
    }

    useEffect(() => {
        setApiIncome();
        setApiCustomerCount();
        setApiCustomerStatus();
        setApiCustomerTopIncome();
        setApiQuontations();
    }, [])

    return (
        <Layout4Admin1 role="admin">
            <div className={Css.Topic}>
                ข้อมูลการขอใช้บริการระบบ DCaaS
            </div>
            <div className={Css.Block_Transparent + ' pb-1'}>
                <div className={Css.Graph_Group}>
                    <CustomerCount total={dashboard.customer_count}
                        active={dashboard.customer_active} />
                    <InCome month_name={dashboard.month_name}
                        income={dashboard.income}
                        awaiting={dashboard.awaiting} />

                    <SuscriptionsCannellationRate total={dashboard.customer_count}
                        active={dashboard.customer_active}
                        nonactive={dashboard.customer_nonactive} />
                </div>

            </div>
            <div className={Css.Block_Transparent + ' pb-1'}>
                <div className={Css.Graph_Group}>
                    <CustomerByStatus status_active={dashboard.status_active}
                        status_draft={dashboard.status_draft}
                        status_hold={dashboard.status_hold}
                        status_nonactive={dashboard.status_nonactive} />
                    <TopCustomerByRevenue data_top={dashboard.arr_customer_top_income} />
                </div>
            </div>
            <div className={Css.Block_Transparent}>
                <div className={Css.Graph_Group}>
                    <InvoiceDetails data={dashboard.arr_quontations} />
                </div>
            </div>
        </Layout4Admin1>
    )
}